import * as React from 'react';
import {Button} from "semantic-ui-react";
import {logoutAdmin} from "../actions/userActions";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_LOGOUT} from "../actions";

const B = ({onLogout, t, processing}) => (
	<Button loading={processing} inverted onClick={onLogout}>{t('actions.logout')}</Button>
);
const m2s = state => ({
	processing: isProcessing(state, PROC_LOGOUT)
});
const m2d = dispatch => ({
	onLogout: () => dispatch(logoutAdmin())
});

export default connect(m2s, m2d)(translate()(B));


// WEBPACK FOOTER //
// ./src/containers/LogoutController.js